import Facebook from './providers/Facebook.js';
import CordovaPurchase from './providers/CordovaPurchase.js';

export default class IAP {
	constructor() {
		if (typeof FBInstant !== 'undefined') {
			this.IAP = new Facebook();
			console.info('IAP class initiated with FBInstant');
		} else if (typeof cordova !== 'undefined') {
			this.IAP = new CordovaPurchase();
			console.info('IAP class initiated with CordovaPurchase');
		} else {
			this.IAP = null;
			this.isAvailable = false;
		}

		if (this.IAP) {
			this.IAP.onBuy = this.IAPOnBuy.bind(this);
			this.isAvailable = true;
		}

		this.catalog = [];

		this.onLoad = function () { };

		this.onBuy = function () { };
	}

	async init(productIds) {
		if (!this.IAP) {
			return;
		}

		await this.IAP.init(productIds);
		// const catalog = await this.IAP.getCatalog();
		// this.catalog = catalog;
		// if (this.onLoad) this.onLoad(catalog);
	}

	getCatalog() {
		if (!this.IAP) {
			return [];
		}

		return this.IAP.getCatalog();
	}

	IAPOnBuy(id) {
		if (this.onBuy) {
			this.onBuy(id);
		}
	}

	buy(id) {
		if (!this.IAP) {
			console.warn('Attempted to buy, but IAP not loaded', id);
			return;
		}

		console.log('Attempting to buy item', id);

		return this.IAP.buy(id);
	}

	restore() {
		if (!this.IAP) {
			return;
		}

		return this.IAP.restore();
	}

	consume(id) {
		if (!this.IAP) {
			return;
		}

		return this.IAP.consume(id);
	}

	getPurchases() {
		if (!this.IAP) {
			return;
		}

		return this.IAP.getPurchases();
	}
}
